import styled from 'styled-components';

import { StyledButton } from '../Button/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 1.714rem;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${StyledButton} {
    width: 8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    margin-top: 16px;
  }
`;

export const CommentBox = styled.div`
  display: flex;
  width: 100%;
  min-height: 10vh;
  gap: 8px;
  margin-top: 48px;
  padding: 1rem 0;
`;

export const CommentTextArea = styled.textarea`
  width: 100%;
  height: 8rem;
  border: 1px solid #dfe1e6;
  border-radius: 5px;
  padding: 1rem;
  resize: none;
`;

export const CommentInput = styled.textarea`
  width: 30rem;
  height: 6rem;
  border: 1px solid #dfe1e6;
  border-radius: 5px;
  padding: 1rem;
  resize: none;
`;

export const CommentsEditContainer = styled.div`
  margin-top: 8px;
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  /* margin-top: 14px; */
  gap: 8px;

  ${StyledButton} {
    width: 4.6rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
  }
`;

export const UserAvatar = styled.div``;

export const CommentInfo = styled.div`
  span {
    padding: 0px 4px;
  }
`;

export const ButtonGhost = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: #4d4d4d;
  border-bottom: 1px solid transparent;

  &:hover {
    border-bottom: 1px solid #b3b3b3;
  }
`;
